module.exports = __webpack_public_path__ + "static/media/error-404.d8293ac3.jpg";